import React from "react";
import Arrow from "../../../../assets/svg/arrow.svg";
import Link from "../../../UI/Link";

const MobileAccordion = ({menuItems = [], expandedMobileItems, toggleMobileItem, Item, submenuStyles, navStyles}) => {
    return (
        <div className={submenuStyles.submenuMega__mobileAccordion}>
            {menuItems.map((item, index) => (
                <div
                    key={`${item?.id ?? "mitem"}-${index}`}
                    className={`${submenuStyles.submenuMega__mobileItem} ${
                        expandedMobileItems.has(index) ? submenuStyles.submenuMega__mobileAccordion_open : ""
                    }`}
                >
                    <button
                        type="button"
                        className={submenuStyles.submenuMega__mobileItemButton}
                        onClick={() => toggleMobileItem(index)}
                    >
                        <Item key={index} item={item} />

                        <Arrow
                            className={`${submenuStyles.submenuMega__mobileItemArrow} ${
                                expandedMobileItems.has(index) ? submenuStyles.expanded : ""
                            }`}
                        />
                    </button>

                    {expandedMobileItems.has(index) && (
                        <div className={submenuStyles.submenuMega__mobileItemContent_expanded}>
                            {item.columns &&
                                item.columns.map((column, colIdx) => (
                                    <div key={colIdx} className={submenuStyles.submenuMega__mobileColumn}>
                                        {column.title && (
                                            <p
                                                className={`${submenuStyles.submenuMega__mobileColumnTitle} ${
                                                    colIdx === 0
                                                        ? submenuStyles.submenuMega__mobileColumnTitle_main
                                                        : ""
                                                }`}
                                            >
                                                {column.title}
                                            </p>
                                        )}
                                        <ul className={submenuStyles.submenuMega__mobileColumnList}>
                                            {column.items &&
                                                column.items.map((contentItem, itemIdx) => (
                                                    <li key={`${contentItem?.id ?? "citem"}-${itemIdx}`}>
                                                        {contentItem.link ? (
                                                            <Link
                                                                className={submenuStyles.submenuMega__mobileColumnLink}
                                                                activeClassName={navStyles.nav__link_active}
                                                                partiallyActive
                                                                to={contentItem.link?.url}
                                                                withArrow={false}
                                                                inNewTab={contentItem.link?.newTab}
                                                            >
                                                                <Item
                                                                    key={contentItem.id ?? itemIdx}
                                                                    item={contentItem}
                                                                />
                                                            </Link>
                                                        ) : (
                                                            <Item key={contentItem.id ?? itemIdx} item={contentItem} />
                                                        )}
                                                    </li>
                                                ))}
                                        </ul>
                                        <div className={submenuStyles.contentColumn__footer}>
                                            {(column.footerLink ||
                                                (Array.isArray(column.footer) && column.footer[0])) && (
                                                <Link
                                                    className={submenuStyles.footerLink}
                                                    partiallyActive
                                                    to={(column.footerLink || column.footer[0]).url}
                                                >
                                                    {(column.footerLink || column.footer[0]).text}
                                                </Link>
                                            )}
                                        </div>
                                    </div>
                                ))}
                        </div>
                    )}
                </div>
            ))}
        </div>
    );
};

export default MobileAccordion;
